<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                element="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.fouls', 2),
                        href: null,
                    },
                    {
                        name: $t('messages.create'),
                        href: null,
                    },
                ]"
            />
        </template>

        <GroupSelector :grade-levels="gradeLevels" :user-grade-levels="meta.preferences.user_grade_levels">
            <template v-slot:default="{ filteredGradeLevels }">
                <div class="mb-2" v-for="gradeLevel in filteredGradeLevels" :key="gradeLevel.id">
                    <AppButton
                        element="inertia-link"
                        v-for="group in gradeLevel.groups"
                        :href="group.url"
                        :key="group.id"
                        desired-action
                        class="mr-2"
                    >
                        {{ group.name }}
                    </AppButton>
                </div>
            </template>
        </GroupSelector>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import GroupSelector from '@/components/GroupSelector.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    components: {
        PanelPage,
        GroupSelector,
        AppButton,
    },
    layout: Layout,
    name: 'Show',
    props: ['meta', 'gradeLevels'],
};
</script>
